import { useRouteMatch } from "react-router-dom";

// Component.
export default function useDistancingArgs() {
  // Current path: distancing/
  const { path } = useRouteMatch();

  const {
    params: { country, state, county },
  } = useRouteMatch({
    path: `${path}/:country?/:state?/:county?`,
    strict: true,
    sensitive: true,
  });

  let level;

  if (!country && !state) {
    level = "world"
  } else if (country && !state) {
    level = "country"
  } else if (country && state && !county) {
    level = "state"
  } else if (country && state && county) {
    level = "county"
  }

  return { country, state, county, level };

}
